module.exports = __webpack_public_path__ + "fa-solid-900.37bc7099f6f1ba802361.svg";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-solid-900.svg
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-solid-900.svg
// module chunks = 2